import {Space, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import TeamFotoGeneral from './TeamFotoGeneral';

const {Title} = Typography;

const TeamC = () => {
  return (
    <Layout className='PurpBack' style={{background: 'white'}}>
      <Layout style={{margin: '50px', background: 'inherit'}}>
        <Title level={1} style={{color: appColors['ColorA'], textAlign: 'center'}}>Communication</Title>
        <Space align="start" style={{background: 'inherit', maxWidth: '100%', justifyContent: 'space-evenly'}}>
          <TeamFotoGeneral foto='https://static.igem.wiki/teams/4464/wiki/team/ximerangel.jpg' nombre='Xime Rangel' carrera='Communication degree' descripcion='She helped organize and execute collaborations with other iGEM teams, such as iGEM UAM and Egypt iGEM. She was in charge of our series of Intersectional Space.' experiencia='The collaborations with the other iGEM teams'/>
          <TeamFotoGeneral foto='https://static.igem.wiki/teams/4464/wiki/team/emi.jpg' nombre='Emi Figueroa' carrera='Marketing degree' descripcion='He was coordinator of the communication area, he has actively led the social media content planning sessions with the communication team, applying marketing strategies, in order to increase growth and maintain relevance. Such as the collaborations with other iGEM teams or the creation of our TikTok account.' experiencia='The event Transforming Aging'/>
          <TeamFotoGeneral foto='https://static.igem.wiki/teams/4464/wiki/team/quetzal.jpg' nombre='Quetzal Rojas' carrera='Biotechnology engineering' descripcion='She helped organize and execute collaborations with other iGEM teams, such as iGEM UAM and Egypt iGEM. She was in charge of our social media series Disruptive Science, and of several of our social media dynamics.' experiencia='The science fair'/>
        </Space>
      </Layout>
    </Layout>
  );
};

export default TeamC;
